import { canvasToScreen, screenToCanvas } from './viewport'

export const RULER_SIZE = 22

export function guideLimit (axis, config) {
  const size = Number(axis === 'horizontal' ? config.height : config.width)
  return Number.isFinite(size) ? Math.max(0, size) : 0
}

// 辅助线保存画布坐标，绘制/拖动时才转换；不随编辑器缩放累积像素误差。
export function guidePosition (guide, viewport) {
  const point = canvasToScreen({ x: guide.value, y: guide.value }, viewport)
  return guide.axis === 'horizontal' ? point.y : point.x
}

export function guideFromPointer (axis, point, rect, viewport, config, grabOffset = 0) {
  const local = screenToCanvas({ x: point.x - (axis === 'vertical' ? grabOffset : 0), y: point.y - (axis === 'horizontal' ? grabOffset : 0) },
    { ...viewport, left: rect.left + RULER_SIZE, top: rect.top + RULER_SIZE })
  const value = Math.round(axis === 'horizontal' ? local.y : local.x)
  const inside = point.x >= rect.left + RULER_SIZE && point.x <= rect.left + rect.width &&
    point.y >= rect.top + RULER_SIZE && point.y <= rect.top + rect.height && value >= 0 && value <= guideLimit(axis, config)
  return { value, inside }
}

export function guideAtCenter (axis, size, viewport, config) {
  const point = screenToCanvas({ x: size.width / 2, y: size.height / 2 }, viewport)
  return Math.round(Math.max(0, Math.min(guideLimit(axis, config), axis === 'horizontal' ? point.y : point.x)))
}
